import type { DraftLineItem, FinancialSummary, Order, OrderLineItem } from "../types";

function getLineItemUnitPrice(
  order: Order,
  lineItemId: string,
): number {
  const lineItem = order.lineItems?.find(
    (li: OrderLineItem) => li.line_item_id === lineItemId,
  );
  const price = parseFloat((lineItem as any)?.price ?? "0");
  return isNaN(price) ? 0 : price * 100;
}

export function calculateTotals(
  lineItems: DraftLineItem[],
  order: Order,
): FinancialSummary {
  const currency = (order.currency as any)?.shopCurrency ?? "EUR";

  let refundTotal = 0;
  let exchangeTotal = 0;
  let discountTotal = 0;

  for (const item of lineItems) {
    const unitPrice = getLineItemUnitPrice(order, item.lineItemId);
    const itemTotal = unitPrice * item.quantity;

    switch (item.resolution) {
      case "refund":
        refundTotal += itemTotal;
        break;
      case "discount":
        discountTotal += itemTotal;
        break;
      case "exchange":
      case "exchange-credit":
        exchangeTotal += itemTotal;
        break;
    }
  }

  const amountDue = Math.max(0, exchangeTotal - refundTotal - discountTotal);

  return { refundTotal, exchangeTotal, discountTotal, amountDue, currency };
}
